import * as types from './actionTypes'

export function setDataset(datasetId) {
    return dispatch => {
        dispatch({ type: types.TABLE_VIEW_SET_DATASET, result:datasetId });
    }
}